// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t-header-anonymous[data-v-0be6ee13]{color:#fff}.t-header-anonymous-gap[data-v-0be6ee13]{gap:var(--sc-spacing-3)}
`, "",{"version":3,"sources":["webpack://./src/common/components/header/THeader.vue"],"names":[],"mappings":"AACA,qCAGE,UAAW,CAEX,yCACE,uBALoC","sourcesContent":["\n.t-header-anonymous {\n  $header-items-gap: var(--sc-spacing-3);\n\n  color: #fff;\n\n  &-gap {\n    gap: $header-items-gap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
